import { dealStatus } from '../../login/utils/Status';
import { Cashflow, Cashflowgraph, Deal } from './redux/types';

export const isShowFields = (status: string) => {
    if (status === dealStatus.completed || status === dealStatus.invested || status === dealStatus.upcoming) {
        return false;
    }
    return true;
};

export const committedValue = (deal: Deal) => {
    let fundingCommitted =
        (deal &&
            deal.info &&
            deal.info.summary &&
            deal.info.summary.fundingCommitted &&
            deal.info.summary.fundingCommitted.amountUpto2dp) ||
        0;
    let targetFundingSize =
        (deal &&
            deal.info &&
            deal.info.summary &&
            deal.info.summary.targetFundingSize &&
            deal.info.summary.targetFundingSize.amountUpto2dp) ||
        0;

    return Math.round((fundingCommitted / targetFundingSize) * 100);
};

export const createMinInvestment = (deal: Deal) => {
    const info = deal.info;
    if (!info) {
        return '';
    }
    let minInvestment = '';
    if (info.summary?.minimumInvestment) {
        info.summary?.minimumInvestment &&
            info.summary?.minimumInvestment.map((investment, index) => {
                if (index === 0 && investment.amountUpto2dp && investment.amountUpto2dp !== 0) {
                    minInvestment = `${investment.currency} ${
                        investment.amountUpto2dp && investment.amountUpto2dp.toLocaleString()
                    }`;
                }
                if (index > 0 && investment.amountUpto2dp && investment.amountUpto2dp !== 0) {
                    minInvestment = `${minInvestment} <br /> ${investment.currency} ${
                        investment.amountUpto2dp && investment.amountUpto2dp.toLocaleString()
                    }`;
                }
                return minInvestment;
            });
    }

    return minInvestment || '-';
};

export const createInterestRate = (deal: Deal) => {
    const info = deal.info;
    if (!info) {
        return '';
    }
    let InterestRate = '';
    if (info.summary?.terms) {
        info.summary?.terms &&
            info.summary?.terms.interestRates &&
            info.summary?.terms.interestRates.map((interest, index) => {
                if (index === 0) {
                    InterestRate = `${interest.ccy} ${interest.interestRate}%`;
                }
                if (index > 0) {
                    InterestRate = `${InterestRate} <br /> ${interest.ccy} ${interest.interestRate}%`;
                }
                return InterestRate;
            });
    }

    return InterestRate;
};

export const hideViewAndDetails = (status: string) => {
    if (!status) {
        return true;
    }
    if (status === dealStatus.invested || status === dealStatus.completed || status === dealStatus.upcoming) {
        return true;
    }
    return false;
};

export const showDetailCards = (status: string) => {
    if (status === dealStatus.active || status === dealStatus.closed) {
        return true;
    }

    return false;
};

function commaSeperator(rawText: string) {
    try {
        const text = String(rawText);
        let arr = text.split('.');
        let integerStr = arr[0];
        let decimalStr = text.indexOf('.') > 0 ? '.' : '';
        if (arr[1]) {
            decimalStr += arr[1];
        }
        const mob = integerStr.length % 3;
        const head = mob > 0 ? integerStr.substring(0, mob) : '';
        const rest = integerStr.substring(mob);
        let body = '';
        if (rest) {
            const chunked = chunkString(rest, 3);
            if (chunked) {
                body = chunked.join(',');
            }
        }
        const result = head + `${mob > 0 && rest ? ',' : ''}` + body + decimalStr;
        return result;
    } catch (e) {
        return rawText;
    }
}

function chunkString(str: string, length: number) {
    return str.match(new RegExp('.{1,' + length + '}', 'g'));
}

const parseCashflow = (cashflow: Cashflow[]): Cashflowgraph[] => {
    let list: Cashflowgraph[] = [];
    cashflow.forEach((c) => {
        if (c.paymentDate?.date) {
            list.push({
                date: c.paymentDate.date,
                interestPayment: c.interestPayment?.amountUpto2dp || 0,
                principalPayment: c.principalRepayment?.amountUpto2dp || 0,
            });
        }
    });

    return list;
};

const commonUtils = {
    commaSeperator,
    parseCashflow,
};

export default commonUtils;
